import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  createBrowserRouter,
  Outlet,
  Route,
  RouterProvider,
  Routes,
  useLocation,
} from "react-router-dom";
import { usePrismicDocumentByUID } from "@prismicio/react";
import ArtistPage from "./pages/ArtistPage";
import LogoWarner from "./assets/img/logo-black.png";
import MainPage from "./pages";

import LogoDisquaireDay from "./assets/img/logo_disquaire_day.png";
import Snow from "./components/Snow";

import "./App.scss";
import { Link } from "react-router-dom";

const CUSTOM_UID = "disquaire-day";

const App = () => {
  const [document] = usePrismicDocumentByUID("disquaireday", "disquaire-day");
  const [artistsData, setArtistsData] = useState(null);
  const [globalData, setGlobalData] = useState(null);

  const Layout = () => (
    <>
      {/* <Header /> */}
      {/* <Link to="/">
        {" "}
        <img className="LogoDisquaireDay" src={LogoDisquaireDay} alt="" />
      </Link> */}
      <div className="header">
        <h1
          style={{
            color: globalData?.maintextcolor ?? "#000",
          }}
        >
          Le <img className="LogoDisquaireDay" src={LogoDisquaireDay} alt="" />{" "}
          avec
          <br />
          <img className="LogoWarner" src={LogoWarner} alt="" />
        </h1>
      </div>
      <Outlet />
    </>
  );

  const dynamicRoutes = artistsData
    ? artistsData.map((el, index) => ({
        path: "/disquaireday/" + el.path[0].text,
        element: (
          <ArtistPage
            globalData={globalData}
            index={index}
            document={document}
            artistsData={artistsData}
          />
        ),
      }))
    : [];

  const router = createBrowserRouter([
    {
      path: "/disquaireday",
      element: <Layout />,
      children: [
        {
          path: "/disquaireday",
          element: (
            <MainPage
              document={document}
              artistsData={artistsData}
              globalData={globalData}
            />
          ),
        },
        ...dynamicRoutes,
        {
          path: "*",
          element: (
            <MainPage
              document={document}
              artistsData={artistsData}
              globalData={globalData}
            />
          ),
        },
      ],
    },
  ]);

  useEffect(() => {
    if (document && document.data && !artistsData) {
      setArtistsData(document.data.genre);
      setGlobalData(document.data);
    }
  }, [document]);

  return (
    <main
      style={
        globalData
          ? {
              color: globalData.backgroundcolor
                ? globalData.backgroundcolor
                : "#fff",
              color: globalData.maintextcolor
                ? globalData.maintextcolor
                : "#000",
            }
          : {}
      }
      className="App"
    >
      <RouterProvider router={router} />
      {/* {globalData && globalData.showsnow && <Snow />} */}
    </main>
  );
};

export default App;
